import { getNativeHeaders } from './getNativeHeaders'

type AppName = 'ios' | 'android'
const KEY = 'NativeAppName'

export const checkIsNativeApp = () => {
  return new RegExp(KEY).test(navigator.userAgent)
}

const getNativeAppName = (): AppName => {
  const regex = new RegExp(`^(.*)(${KEY})/(ios|android)(.*)$`)
  return (navigator.userAgent).replace(regex, '$3') as AppName
}

export const checkIsIos = () => {
  return checkIsNativeApp() && getNativeAppName() === 'ios'
}

export const checkIsAndroid = () => {
  return checkIsNativeApp() && getNativeAppName() === 'android'
}

export const openAuth = (authUrl: string) => {
  if (checkIsNativeApp()) {
    const appName = getNativeAppName()
    try {
      switch (appName) {
        case 'ios':
          window.webkit.messageHandlers.OpenAuth.postMessage(authUrl)
          break

        case 'android':
          window.Android.openAuth(authUrl)
          break

        default: {
          throw new Error('Wrong app name')
        }
      }
    } catch (error) {
      console.error(error)
    }
  }
}

export const authorize = (stringifyAuthData: string) => {
  if (checkIsNativeApp()) {
    const appName = getNativeAppName()
    try {
      switch (appName) {
        case 'ios':
          window.webkit.messageHandlers.Authorize.postMessage(stringifyAuthData)
          break

        case 'android':
          window.Android.authorize(stringifyAuthData)
          break

        default: {
          throw new Error('Wrong app name')
        }
      }
    } catch (error) {
      console.error(error)
    }
  }
}

export const changeTheme = (theme: app.ThemeMode) => {
  if (checkIsNativeApp()) {
    const appName = getNativeAppName()
    try {
      switch (appName) {
        case 'ios':
          window.webkit.messageHandlers.ChangeTheme.postMessage(theme)
          break

        case 'android':
          window.Android.changeTheme(theme)
          break

        default: {
          throw new Error('Wrong app name')
        }
      }
    } catch (error) {
      console.error(error)
    }
  }
}

export const registerPushNotifications = (forceChange: boolean) => {
  if (checkIsNativeApp()) {
    const appName = getNativeAppName()
    try {
      switch (appName) {
        case 'ios':
          window.webkit.messageHandlers.RegisterPushNotifications.postMessage(getNativeHeaders(forceChange))
          break

        case 'android':
          window.Android.registerPushNotifications(getNativeHeaders(forceChange))
          break

        default: {
          throw new Error('Wrong app name')
        }
      }
    } catch (error) {
      console.error(error)
    }
  }
}

export const unregisterPushNotifications = (removeFromServer: boolean) => {
  if (checkIsNativeApp()) {
    const appName = getNativeAppName()
    try {
      switch (appName) {
        case 'ios':
          window.webkit.messageHandlers.UnregisterPushNotifications.postMessage(
            removeFromServer ? getNativeHeaders() : null
          )
          break

        case 'android':
          if (removeFromServer) {
            window.Android.unregisterPushNotifications(getNativeHeaders())
          } else {
            window.Android.unregisterPushNotifications()
          }
          break

        default: {
          throw new Error('Wrong app name')
        }
      }
    } catch (error) {
      console.error(error)
    }
  }
}

export const checkPushNotificationStatus = () => {
  if (checkIsNativeApp()) {
    const appName = getNativeAppName()
    try {
      switch (appName) {
        case 'ios':
          window.webkit.messageHandlers.CheckPushNotifications.postMessage(null)
          break

        case 'android':
          window.Android.checkPushNotifications()
          break

        default: {
          throw new Error('Wrong app name')
        }
      }
    } catch (error) {
      console.error(error)
    }
  }
}

export const exportLogsInIos = () => {
  if (checkIsIos()) {
    console.log = function (log) {
      window.webkit.messageHandlers.Console.postMessage(JSON.stringify(log))
    }
    console.debug = console.log;
    console.info = console.log;
    console.warn = console.log;
    console.error = console.log;

    window.onerror = function (error, url, line) {
      console.log('ERROR: ' + error + ' URL:' + url + ' L:' + line);
    }
  }
}
